import { useCallback, useRef } from "react";

import { useCreateSubscription, useTokenize } from ".";

export function useSubscriptionService(onDone = () => {}, onError = () => {}) {
  const cbInstanceRef = useRef();
  const [tokenize, submittingToken] = useTokenize(cbInstanceRef);
  const [createSubscription, submittingSub] = useCreateSubscription();

  const createAccount = useCallback(
    async ({ plan, coupons, ...billingInfo }) => {
      try {
        const { token } = await tokenize({
          firstName: billingInfo.firstName,
          lastName: billingInfo.lastName,
          addressLine1: billingInfo.address,
          city: billingInfo.city,
          zip: billingInfo.zipCode,
          countryCode: billingInfo.country.code,
        });

        const msg = await createSubscription({
          token: token,
          plan: plan,
          coupons: coupons,
          billingInfo: { ...billingInfo, country: billingInfo.country.code },
        });

        return onDone({ token, msg });
      } catch (e) {
        return onError(e);
      }
    },
    [tokenize, createSubscription, onDone, onError]
  );

  return {
    createAccount: createAccount,
    submitting: submittingToken || submittingSub,
    cbInstanceRef: cbInstanceRef,
  };
}

export default useSubscriptionService;
